import { post } from './request'

// 获取问卷信息
export const submit = data => {
  return post('/answer/submit_question', data)
}
